import React from "react";
import Box from "@mui/material/Box";
const sxStyles = {
    root: {
        display: "flex",
        flex: 1,
        flexFlow: "column nowrap",
        justifyContent: "stretch",
        alignItems: "stretch",
        width: "100%",
    },
};
const AppWrapper = ({ children }) => React.createElement(Box, { sx: sxStyles.root }, children);
export default AppWrapper;
//# sourceMappingURL=AppWrapper.js.map